export default {
    JANEIRO: 1,
    FEVEREIRO: 2,
    MARCO: 3,
    ABRIL: 4,
    MAIO: 5,
    JUNHO: 6,
    JULHO: 7,
    AGOSTO: 8,
    SETEMBRO: 9,
    OUTUBRO: 10,
    NOVEMBRO: 11,
    DEZEMBRO: 12,
        
    properties: {
        1: { nome: 'Janeiro', nomeAbreviado: 'Jan' },
        2: { nome: 'Fevereiro', nomeAbreviado: 'Fev' },
        3: { nome: 'Março', nomeAbreviado: 'Mar' },
        4: { nome: 'Abril', nomeAbreviado: 'Abr' },
        5: { nome: 'Maio', nomeAbreviado: 'Mai' },
        6: { nome: 'Junho', nomeAbreviado: 'Jun' },
        7: { nome: 'Julho', nomeAbreviado: 'Jul' },
        8: { nome: 'Agosto', nomeAbreviado: 'Ago' },
        9: { nome: 'Setembro', nomeAbreviado: 'Set' },
        10: { nome: 'Outubro', nomeAbreviado: 'Out' },
        11: { nome: 'Novembro', nomeAbreviado: 'Nov' },
        12: { nome: 'Dezembro', nomeAbreviado: 'Dez' }
    }
}